import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('No se ha encontrado #root en index.html');
const root = createRoot(container);

/*
 * `/estilo` solo existe en dev: import.meta.env.DEV se sustituye por una constante en
 * build de producción, y el `if` muerto se elimina junto con el import dinámico, así
 * que StyleGuidePage nunca llega al bundle ni al chunk servido en producción.
 */
async function bootstrap() {
  if (import.meta.env.DEV && window.location.pathname === '/estilo') {
    const { StyleGuidePage } = await import('./design/StyleGuidePage');
    root.render(
      <StrictMode>
        <StyleGuidePage />
      </StrictMode>,
    );
    return;
  }
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
